module.exports = __webpack_public_path__ + "img/info_people.ef5c9cfe.png";